module.exports = __webpack_public_path__ + "img/documentImage.b937ac34.svg";